export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/combination-merchant-icon.a27fdb5c-d4a763.png";